import React, { useEffect, useState } from "react";
import {
  FooterContainer,
  FooterLine,
  FooterCopyright,
  FooterLinkContainer,
  FooterSocialMedia,
} from "./Footer.styled";
import { fipay } from "../../../public/assets";
import { footerLinks, socialMedia } from "../../constants/index";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);
  const navigate = useNavigate();
  const toHomePage: () => void = () => {
    navigate("/");
  };
  return (
    <FooterContainer>
      <div className="Footer_Div">
        <div>
          <img
            src="/assets/icons/fipay.svg"
            alt="fipay"
            className="fipay_footer_img"
            onClick={toHomePage}
          />
          <div className="Footer_Div1">
            <p className="Footer_Paragraph">
              338 Main Street, <br /> San Francisco, California, 94105.
            </p>
            <p className="Footer_Mail">Contact@fipay.io</p>
          </div>

          <FooterSocialMedia>
            {socialMedia.map((social, index) => (
              <img
                key={social.id}
                src={social.icon}
                alt={social.id}
                className={`w-[21px] h-[21px] object-contain cursor-pointer ${
                  index !== socialMedia.length - 1 ? "mr-6" : "mr-0"
                }`}
                onClick={() => window.open(social.link)}
              />
            ))}
          </FooterSocialMedia>
        </div>

        <FooterLinkContainer>
          {footerLinks.map((footerlink) => (
            <div key={footerlink.title} className="Footer_Link_Div2">
              <h4 className="Footer_Link_Title">
                {t(footerlink.title, { lng: currentLocale })}
              </h4>
              <ul className="Footer_Links">
                {footerlink.links.map((link) => (
                  <li key={link.name} className="Footer_Link_Name">
                    <Link to={`${link.link || ""}`}>
                      {t(link.name, { lng: currentLocale })}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </FooterLinkContainer>
      </div>
      <FooterLine></FooterLine>

      <FooterCopyright>
        <p>Copyright {currentYear} @fipay.io</p>
      </FooterCopyright>
    </FooterContainer>
  );
};

export default Footer;
